import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=d5c56bdc&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5c56bdc')) {
      api.createRecord('d5c56bdc', component.options)
    } else {
      api.reload('d5c56bdc', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=d5c56bdc&", function () {
      api.rerender('d5c56bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8AcmlQw3fHX0p/JS/comp/ImgFallback.vue"
export default component.exports